import queryString from 'query-string';

export const getUrlQuery = (_state, props) =>
  queryString.parse(props.location.search);
export const getRouteParam = (_state, props, param) =>
  props.match.params[param];
export const getUrlPathname = (_state, props) => props.match.url;
